import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-start",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class StartButtonComponent extends EceButtonComponent {
  icon = "play";
}
